module.exports = __webpack_public_path__ + "img/nx.2be14365.jpg";